import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { fetchQuery, graphql } from "relay-runtime";
import z from "zod";
import { hubQRLandingPageQuery } from "./__generated__/hubQRLandingPageQuery.graphql";

export const Route = createFileRoute("/hub/$hubMetaName/")({
    beforeLoad: () => {
        document.title = 'bacehub | Startseite'
    },
	component: RouteComponent,
	validateSearch: zodValidator(
		z.object({
			side: z.string().optional(),
		})
	),
	loaderDeps: ({ search: { side } }) => ({ side }),
	loader: async (ctx) => {
		const { hubMetaName } = ctx.params;
		try {
			const data = await fetchQuery<hubQRLandingPageQuery>(
				ctx.context.relayEnvironment,
				graphql`
					query hubQRLandingPageQuery($hubMetaName: String!) {
						hubMeta(by: { name: $hubMetaName }) @required(action: THROW) {
							hub @required(action: THROW) {
								id
							}
						}
					}
				`,
				{ hubMetaName }
			).toPromise();
			if (!data) {
				throw redirect({
					to: "/$hubMetaName/instant-buy",
					params: {
						hubMetaName,
					},
				});
			}

			localStorage.setItem(
				"hub-session",
				JSON.stringify({
					hub: {
						id: data.hubMeta.hub.id,
						name: hubMetaName,
						// Hubs without sides only have frames with A1, A2, A3, etc.
						side: (ctx.deps.side?.toUpperCase() ?? "A") as "A" | "B",
					},
					timestamp: Date.now(),
				})
			);
		} catch (error) {
			console.error(error);
			throw redirect({
				to: "/$hubMetaName/instant-buy",
				params: {
					hubMetaName,
				},
			});
		}

		throw redirect({
			to: "/",
		});
	},
});

function RouteComponent() {
	return <div>Hello "/hub/$hubMetaName/"!</div>;
}
